export default {
  login: 'Login',
  logout: 'Logout',
  username: 'Username',
  password: 'Password',
  rememberMe: 'Remember Me',
  forgotPassword: 'Forgot Password?',
  loginSuccess: 'Login Successful',
  loginFailed: 'Login Failed',
  unauthorized: 'Unauthorized, please login again',
  forbidden: 'Permission Denied',
};
